import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { BaseStationChartStyle } from './BaseStationChart.styled';
import Color from '../../common/ColorEnum';

ChartJS.register(ArcElement, Tooltip, Legend);

const BaseStationChart = ({datasetIdKey,data={online:0,offline:0,snoozed:0},percentageData=[],module=""}) => {

    const labelfunction=(tooltipItem)=>{
        const statusarr=["Online","Offline","Snooze"]
        const status=statusarr[tooltipItem.dataIndex]
        const percentage=percentageData[tooltipItem.dataIndex]
        const message=`Active Beacons Reporting ${status} : ${tooltipItem.parsed} - ${percentage}%`
        return message
    }

    const options = {
        tooltips: {
            callbacks: {
            label: labelfunction,
            },
        },
    };
  return (
    <BaseStationChartStyle>
        <p className='chartheading'>{module}</p>
        <div className='chartdiv'>

            <Doughnut 
                datasetIdKey={datasetIdKey}
                options={{
                    plugins:{
                        tooltip:{
                            callbacks:{
                                label:labelfunction
                            }
                        }
                    }
                }}
                data={{
                    labels:["Online","Offline","Snooze"], 
                    fill:false,
                    datasets:[
                        {
                            data:[data.online,data.offline,data.snoozed],
                            backgroundColor: [
                                `${Color.online}`,
                                `${Color.offline}`,
                                `${Color.snoozed}`
                            ],
                            hoverOffset: 4,
                        }
                    ]
                }}
            
            />
        </div>
    </BaseStationChartStyle>
  )
}

export default BaseStationChart